import React from "react";
import "../pages/ErrorPage.css";

const ErrorPage = () => {
  return (
    <>
      <div
        className="messageContainer"
      >

        <h1 className="errorNumber">404</h1>
        <h2 className="messageTitle">Página no encontrada</h2>
      </div>
        <h3 className="messageDescription">La página a la que estás intentando acceder no existe o ha sido eliminada</h3>
    </>
  );
};
export default ErrorPage;
